import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=476f6c0a&"
import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports